import React from "react";
import "./styles.scss";

function SectionHeader(props) {
  return (
    <>
      {(props.title || props.subtitle) && (
        <header
          style={{
            marginBottom: '2.5%'
          }}
          className={
            (props.centered ? " is-centered" : "")
          }
        >
          {props.title && (
            <p
              className={
                "title has-text-weight-bold" +
                (props.titleFont || "") +
                (props.size ? ` is-${props.size}` : "") +
                (props.size === 1 ? " is-size-2-mobile" : "") +
                (props.textCentered ? " has-text-centered" : "") +
                (props.spaced ? " is-spaced" : "")
              }
            >
              {props.title}
            </p>
          )}

          {props.subtitle && (
            <p 
              className={"subtitle" + 
                (props.subtitleFont || "") +
                (props.size > 4 ? " is-6" : "") +
                (props.textCentered ? " has-text-centered" : "") + 
                (props.subtitleColor || "") + 
                (props.subSpaced ? " is-spaced" : "")
              }
            >
              {props.subtitle}
            </p>
          )}
        </header>
      )}
    </>
  );
}

export default SectionHeader;
